import React, { createContext, useContext, ReactNode, useEffect } from 'react';
import { useApiCallLimit } from '../hooks/useApiCallLimit';
import { setApiLimitFunctions } from '../services/travelApi';

interface ApiLimitContextType {
  callCount: number;
  limitReached: boolean;
  remainingCalls: number;
  incrementCallCount: () => void;
  resetCallCount: () => void;
  API_CALL_LIMIT: number;
}

const ApiLimitContext = createContext<ApiLimitContextType | undefined>(undefined);

export const ApiLimitProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const apiLimitState = useApiCallLimit();

  // Set the API limit functions in the travel API service
  useEffect(() => {
    setApiLimitFunctions({
      incrementCallCount: apiLimitState.incrementCallCount
    });
  }, [apiLimitState.incrementCallCount]);

  return (
    <ApiLimitContext.Provider value={apiLimitState}>
      {children}
    </ApiLimitContext.Provider>
  );
};

export const useApiLimit = () => {
  const context = useContext(ApiLimitContext);
  if (!context) {
    throw new Error('useApiLimit must be used within an ApiLimitProvider');
  }
  return context;
}; 